"use client"

import { useState, useEffect } from "react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import axios from "axios";
import { toast } from 'sonner';
import { setUserData } from "@/store/mainSlice";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from 'next/navigation';
import Select from 'react-select';
import countryJson from "./country.json"
import { email } from "zod/v4";
import { setFetchUserData } from "@/store/mainSlice";

const options = [
  { value: "🎁 Ambivert", label: "🎁 Ambivert" },
  { value: "😄 Optimist", label: "😄 Optimist" },
  { value: "⚖️ Open-minded", label: "⚖️ Open-minded" },
  { value: "🙋 Perfectionist", label: "🙋 Perfectionist" },
  { value: "🤧 Empathetic", label: "🤧 Empathetic" },
  { value: "🌟 Spiritual", label: "🌟 Spiritual" },
  { value: "👍 Independent", label: "👍 Independent" },
  { value: "💭 Analytical", label: "💭 Analytical" },
  { value: "😍 Adventurous", label: "😍 Adventurous" },
  { value: "✨ Fun-loving", label: "✨ Fun-loving" },
];

export function AuthForm({ setIsSuccessful, children, defaultEmail = "", handleClose }) {
  const [formData, setFormData] = useState({
    name: "",
    gender: "",
    dob: ""
  });
  const [personality, setPersonality] = useState("😄 Optimist");
  const [country, setCountry] = useState("");
  const [countryForSelect, setCountryForSelect] = useState("");
  const [image, setImage] = useState("");
  const [isDark, setIsDark] = useState(false);
  const dispatch = useDispatch()
  const router = useRouter()
  const { userData } = useSelector((state) => state.main)


  useEffect(() => {
    if (userData.is_profile_complete == 1) {
      setFormData({
        name: userData.name,
        gender: userData.gender,
        dob: new Date(userData.date_of_birth).toISOString().split("T")[0],
        email: userData.email,
      })
      // setPersonality(userData.personality)
      // setPersonalityForSelect(options.find((data) => data.value == userData.personality))
      if (userData.country) {
        setCountry(userData.country)
        let country = Object.values(countryJson.country).find(
          (data) => `${data.flag} ${data.name}` === userData.country
        )
        setCountryForSelect(
          {
            value: `${country?.flag} ${country?.name}`,
            label: `${country?.flag} ${country?.name}`,
          }
        );
      }

      setImage(userData.image_path)
    } else {
      // console.log(userData, "userDatauserData")
      setFormData({
        name: userData.name,
        email: userData.email,
      })
      setImage(userData.image_path)
    }
  }, [userData])


  const handleImage = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setImage(file);
    }
  }
 

  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsDark(document.documentElement.classList.contains("dark"));
    }
  }, []);


  const handleChange = (e) => {
    const key = e.target.name;
    const value = e.target.value;
    // console.log(key, value)
    setFormData((old) => {
      return {
        ...old,
        [key]: value
      }
    });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name) {
      toast.error("Name is required!", {
        style: { color: "red" },
        position: "top-center",
        iconTheme: { primary: "red", secondary: "#fff" }
      });
      return;
    }
    if (!formData.gender) {
      toast.error("Gender is required!", {
        style: { color: "red" },
        position: "top-center",
        iconTheme: { primary: "red", secondary: "#fff" }
      });
      return;
    }
    if (!formData.dob) {
      toast.error("Date of Birth is required!", {
        style: { color: "red" },
        position: "top-center",
        iconTheme: { primary: "red", secondary: "#fff" }
      });
      return;
    }
    // Convert entered DOB to Date object
    const dobDate = new Date(formData.dob);
    const today = new Date();

    // Prevent future dates
    if (dobDate > today) {
      toast.error("Date of Birth cannot be in the future!", {
        style: { color: "red" },
        position: "top-center",
        iconTheme: { primary: "red", secondary: "#fff" },
      });
      return;
    }
    if (!country) {
      toast.error("Country is required!", {
        style: { color: "red" },
        position: "top-center",
        iconTheme: { primary: "red", secondary: "#fff" }
      });
      return;
    }
    setIsSuccessful(true)
    try {
      let datasend = {
        name: formData.name,
        gender: formData.gender,
        date_of_birth: formData.dob,
        personality: personality,
        email: userData.email,
        image: image,
        country: country,
      };
      const res = await axios.post(process.env.NEXT_PUBLIC_APP_SEND_COMPLETE_PROFILE,
        datasend,
        {
          headers: {
            "x-auth-token": localStorage.getItem("authToken"),
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (res.data.status == 1 && res.data.isProfileComplete === true) {
        toast.success("Profile Completion Successful.", {
          style: { color: "green" },
          position: "top-center",
          iconTheme: { primary: "green", secondary: "#fff" },
        });
        dispatch(setFetchUserData(Date.now()))
        handleClose()
      }
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("userId");
        toast.error("Session expired. Redirecting to login.", {
          style: { color: "red" },
          position: "top-center",
          iconTheme: { primary: "red", secondary: "#fff" },
        });
        router.push("/login");
      } else {
        toast.error(err?.response?.data?.message || "Something went wrong", {
          style: { color: "red" },
          position: "top-center",
          iconTheme: { primary: "red", secondary: "#fff" },
        });
      }
    } finally {
      setIsSuccessful(false)
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col gap-4 sm:px-0 px-0"
    >
      <div className="flex flex-col gap-4">
        <Label
          className="font-normal text-zinc-600 dark:text-zinc-400"
          htmlFor="email"
        >
          Upload Image
        </Label>
        {image && (
          <img
            src={
              typeof image === "string"
                ? !image.includes("storage") ? image : `${process.env.NEXT_PUBLIC_APP_URL_LOCAL}/${image}` // server path
                : URL.createObjectURL(image) // local file preview
            }
            alt="Uploaded"
            className="w-32 h-32 object-cover rounded-full border"
          />
        )}
        <input
          type="file"
          accept="image/*"
          onChange={handleImage}
          className="border p-2 rounded w-full rounded-xl dark:bg-neutral-800/80 bg-white border border-white/10 p-3 text-sm focus:ring-2 focus:ring-white/30"
        />

      </div>
      <div className="flex flex-col gap-2">
        <Label
          className="font-normal text-zinc-600 dark:text-zinc-400"
          htmlFor="name"
        >
          Enter Your Name<span className="text-red-500">*</span>
        </Label>

        <Input
          autoComplete="name"
          autoFocus
          className="bg-muted text-md md:text-sm h-12 w-full rounded-xl dark:bg-neutral-800/80 bg-white border border-white/10 p-3 text-sm focus:ring-2 focus:ring-white/30"
          id="name"
          name="name"
          placeholder="Enter name"
          required
          type="text"
          value={formData.name}
          onChange={handleChange}
        />
      </div>
      <div className="flex flex-col gap-2">
        <Label className="font-normal text-zinc-600 dark:text-zinc-400">
          Gender<span className="text-red-500">*</span>
        </Label>
        <div className="flex gap-4">
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="gender"
              value="Male"
              checked={formData.gender === "Male"}
              onChange={handleChange}
            />
            Male
          </label>
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="gender"
              value="Female"
              checked={formData.gender === "Female"}
              onChange={handleChange}
            />
            Female
          </label>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <Label htmlFor="dob" className="font-normal text-zinc-600 dark:text-zinc-400">
          Date of Birth<span className="text-red-500">*</span>
        </Label>
        <Input
          type="date"
          id="dob"
          name="dob"
          required
          value={formData.dob}
          onChange={handleChange}
          max={new Date().toISOString().split("T")[0]}
          className="h-12 w-full rounded-xl dark:bg-neutral-800/80 bg-white border border-white/10 p-3 text-sm focus:ring-2 focus:ring-white/30 w-full max-w-full box-border p-2 border appearance-none"
        />
      </div>

      {/* <div className="flex flex-col gap-2">
        <Label className="font-normal text-zinc-600 dark:text-zinc-400">Personality<span className="text-red-500">*</span></Label>
        <Select
          options={options}
          onChange={(e) => {
            setPersonality(e.value)
            setPersonalityForSelect(e)
          }}
          value={personalityForSelect}
          placeholder="Select your personality"
          menuPlacement="top"
          menuPosition="fixed"
          styles={{
            control: (provided, state) => ({
              ...provided,
              textAlign: "left",
              padding: "7px",
              border: "1px solid #ffffff1a",
              borderRadius: "8px",
              backgroundColor: isDark ? "#262626cc" : "#fff",
              color: isDark ? "#fafafa" : "#333",
            }),
            menu: (provided) => ({
              ...provided,
              textAlign: "left",
              padding: "7px",
              backgroundColor: isDark ? "#262626cc" : "#fff",
              color: isDark ? "#fafafa" : "#333",
            }),
            option: (provided, state) => ({
              ...provided,
              backgroundColor: state.isSelected
                ? "#FF7027"              // selected option
                : isDark
                  ? "#262626cc"            // dark mode background
                  : "#fff",                // light mode background
              color: state.isSelected
                ? "#fff"
                : isDark
                  ? "#fafafa"
                  : "#333",
              ":hover": {
                backgroundColor: "#FF7027",
                color: "#fff",
              },
            }),
          }}
        />
      </div> */}
      <div className="flex flex-col gap-2">
        <Label className="font-normal text-zinc-600 dark:text-zinc-400">Country<span className="text-red-500">*</span></Label>
        <Select
          isSearchable={true}
          options={Object.keys(countryJson.country).map((key) => ({
            value: `${countryJson.country[key].flag} ${countryJson.country[key].name}`,
            label: `${countryJson.country[key].flag} ${countryJson.country[key].name}`,
          }))}
          menuPlacement="top"
          // menuPosition={{ fixed: "bottom" }}\
          menuPosition="fixed"
          placeholder="Country"
          value={countryForSelect}
          onChange={(e) => {
            setCountry(e.value)
            setCountryForSelect(e)
          }}
          styles={{
            control: (provided, state) => ({
              ...provided,
              textAlign: "left",
              padding: "7px",
              border: "1px solid #ffffff1a",
              borderRadius: "8px",
              backgroundColor: isDark ? "#262626cc" : "#fff",
              color: isDark ? "#fafafa" : "#333",
            }),
            singleValue: (provided) => ({
              ...provided,
              color: isDark ? "#fff" : "#333",   // 👈 selected text color
            }),
            input: (provided) => ({
              ...provided,
              color: isDark ? "#fff" : "#333",   // 👈 typing text color
            }),
            menu: (provided) => ({
              ...provided,
              textAlign: "left",
              padding: "7px",
              backgroundColor: isDark ? "#262626cc" : "#fff",
              color: isDark ? "#fafafa" : "#333",
            }),
            option: (provided, state) => ({
              ...provided,
              backgroundColor: state.isSelected
                ? "#FF7027"              // selected option
                : isDark
                  ? "#262626cc"            // dark mode background
                  : "#fff",                // light mode background
              color: state.isSelected
                ? "#fff"
                : isDark
                  ? "#fafafa"
                  : "#333",
              ":hover": {
                backgroundColor: "#FF7027",
                color: "#fff",
              },
            }),
          }}
        />
      </div>


      {children}
    </form>
  );
}

